import { Injectable, signal } from '@angular/core';
import { User } from 'src/app/models/user';

@Injectable({
  providedIn: 'root'
})
export class UserStateService {
  private currentUserSignal = signal<User | null>(null);

  setCurrentUser(user: User | null) {
    this.currentUserSignal.set(user);
  }

  getCurrentUser() {
    return this.currentUserSignal();
  }

  getCurrentUserSignal() {
    return this.currentUserSignal;
  }
}
